/**
 * Make the Application global (window) available to use it.
 */

import "./StaticVideoJsCustomizing";
import {videojs} from "../components/wrappers/PlayerComponentWrapper";


/**
 * Why we use this object?
 * This extra, empty static object hide away the default init function on the videojs object it self
 *
 * All real modification on the videojs object MUST made in StaticVideoJsCustomizing file
 * On this topmost inheritance level no changes can be made, that we don't get later a mess with the references when a static function from videojs or from us use this
 */

// Create empty class object
interface IStaticVideoJs extends VideoJSStatic{
    new():IStaticVideoJs;
}
let IStaticVideoJs = <IStaticVideoJs><any>(function(){});
class StaticSkyClickPlayer extends IStaticVideoJs{}

// Define static videojs object as inherited object
// Now is the main function of videojs overwritten and we can use for SkyClick the new method "setup", that is defined in the videojs object
(<any>StaticSkyClickPlayer).__proto__ = videojs;


// Publish ready SkyClick init function globally
(<any>window).SkyClick = StaticSkyClickPlayer;


// WEBPACK FOOTER //
// ./src/app/static/StaticSkyClick.ts